import React, { useEffect, useState, useContext } from 'react';
import { fetchOrbits, fetchPriceListValue } from '../../apiCall';
import Context from '../../context/context';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function PriceList() {
  const [allOrbits, setOrbits] = useState([]);
  const { state } = useContext(Context);

  const [priceListValue, setPriceListValue] = useState([]);

  useEffect(() => {
    console.log(state);
    getPriceListValue();
  }, []);

  const getPriceListValue = () => {
    fetchPriceListValue((response) => {
      console.log(response);
      const items = Array.isArray(response?.result)
        ? response.result
        : Array.isArray(response)
        ? response
        : [];
      setPriceListValue(items);
    });
  };

  const getOrbits = () => {
    fetchOrbits('sadir', function (response) {
      if (!response?.result) return;
      const sortedOrbits = response.result.sort((a, b) => {
        if (a.code < b.code) return -1;
        if (a.code > b.code) return 1;
        return 0;
      });
      setOrbits(sortedOrbits);
    });
  };

  const visibleEntries = priceListValue
    .filter((entry) => {
      const flag = entry?.showToCustomers;
      return flag === true || flag === 'true' || flag === 1;
    })
    .sort((a, b) => {
      const aIndex = Number(a?.index ?? 0);
      const bIndex = Number(b?.index ?? 0);
      return aIndex - bIndex; // ascending by entry.index
    });

  const orbits = [
    { name: 'אומן ~ יאשי', price: '75$' },
    { name: 'אומן ~ קישינב', price: '75$' },
    { name: "אומן ~ סוצ'אבה\t", price: '100$' },
    { name: 'אומן ~ ליזענסק', price: '60$' },
    { name: 'אומן ~ וולעדניק', price: '50$' },
    { name: 'אומן ~ בוקרשט', price: '100$' },
    { name: 'אומן ~ קרעסטעיר', price: '100$' },
    { name: 'אומן ~ האדיטש', price: '50$' },
    { name: 'מזיבוז ~ קישינב', price: '75$' },
    { name: 'יאשי ~ אומן', price: '75$' },
    { name: 'קישינב ~ אומן', price: '75$' },
    { name: 'ליזענסק ~ אומן', price: '60$' },
    { name: "סצ'ובה ~ אומן", price: '100$' },
    { name: 'בוקרשט ~ אומן', price: '100$' },
    { name: 'קרעסטעיר ~ אומן', price: '100$' },
    { name: 'קישינב ~ מזיבוז', price: '75$' }
  ];

  return (
    <div>
      <SideBar />
      <TopBaner />
      <div className="card price-list">
        <h2 className="price-listTitle">מחירון קו סדיר</h2>
        <div className="price-list-container">
          <table className="orbit-table">
            <thead>
              <tr>
                <th>שם</th>
                <th>מחיר למושב</th>
              </tr>
            </thead>
            <tbody>
              {visibleEntries.map((entry, index) => (
                <tr key={entry?.id ?? index}>
                  <td
                    style={{
                      padding: '8px',
                      textAlign: 'center',
                      border: '1px solid #ddd'
                    }}
                  >
                    {entry?.route}
                  </td>
                  <td
                    style={{
                      padding: '8px',
                      textAlign: 'center',
                      border: '1px solid #ddd'
                    }}
                  >
                    {entry?.price}$
                  </td>
                </tr>
              ))}
              {visibleEntries.length === 0 && (
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center', padding: '12px' }}>
                    אין פריטים להצגה ללקוחות
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PriceList;
